import React from "react"
import Typography from '@mui/material/Typography';


export const TextSyndrome = () => {

return(
<div>

Metabolic syndrome is the name for a group of risk factors for heart disease, diabetes, and other health problems. 
You can have just one risk factor, but people often have several of them together. When you have at least three of them, 
it is called metabolic syndrome. These risk factors include:<br /><br />

- A large waistline, also called abdominal obesity or "having an apple shape." Too much fat around the stomach is a greater risk factor for heart disease 
than too much fat in other parts of the body.<br /><br />

- Having a high triglyceride level. Triglycerides are a type of fat found in the blood.<br /><br />

- Having a low HDL cholesterol level. HDL is sometimes called the "good" cholesterol because it helps remove cholesterol from your arteries.<br /><br />
- Having high blood pressure. If your blood pressure stays high over time, it can damage your heart and lead to other health problems.<br /><br />
- Having a high fasting blood sugar. Mildly high blood sugar may be an early sign of diabetes.<br /><br />

The more factors you have, the higher your risk for heart disease, diabetes, and stroke is.

<br /><br />

<Typography component="span" variant="h5" sx={{fontWeight: '700'}}>Gut microbiota and metabolic syndrome: </Typography>
<br /><br />

Metabolic syndrome describes a set of risk factors that can eventually lead to the occurrence of cardiovascular and cerebrovascular disease. 
A detailed understanding of the MetS mechanism will be helpful in developing effective prevention strategies and appropriate intervention tools. 
There is a relationship between the clinical symptoms of Metabolic syndrome and differences in the gut microbial community compared with healthy individuals, 
characterized by the proliferation of potentially harmful bacteria and the inhibition of beneficial ones. <br /><br />

Interactions between gut microbiota and host metabolism have been shown to be mediated by a number of factors, 
including inflammation caused by gut barrier defects, short-chain fatty acids metabolism, and bile acid metabolism. <br /><br />
However, although we can clearly establish a causal relationship between gut microbial profiles and Metabolic syndrome in animal experiments, 
the relationship between them is still controversial in humans. 
Therefore, we need more clinical studies to augment our understanding of how we can manipulate the gut microbiota and address the role of the gut microbiota 
in the prevention and treatment of MetS.

</div>
)
}